<template>
  <ab-modal
    :title="modalTitle ? modalTitle : `搜索结果：“${keywords}”`"
    :errorMsgStatus="errorMsgStatus"
    :visible="visible"
    :confirm-loading="confirmLoading"
    footer=" "
    @cancel="handleCancel"
    width="100%"
  >
    <div class="ab-list">
      <a-spin
        style="width: 100%; height: 100%; align-items: center; display: flex; justify-content: center;"
        v-if="loading"
      >
      </a-spin>

      <div style="width: 100%; height: 100%" v-else>
        <div class="block-tableHeader">
          <a-table
            :columns="columns"
            :data-source="headerBody"
            :showHeader="false"
            :pagination="false"
            rowKey="id"
          />
        </div>
        <div class="block-tableBody">
          <a-table
            :columns="columns"
            :showHeader="false"
            :pagination="false"
            :expandRowByClick="true"
            :data-source="sourceData"
            rowKey="id"
            @expandedRowsChange="expandedRowsChange"
            :expandedRowKeys="expandedRowKeys"
          >
            <div
              slot="expandedRowRender"
              slot-scope="record"
              style="margin: 0;    position: relative;"
            >
              <!-- {{ record.exportCustomerName }} -->
              <div class="clearfix">
                <a-row :gutter="[30, 16]">
                  <a-col :span="6">
                    <div class="item">
                      <div class="item-title fontSize20">
                        企业详情
                      </div>
                      <div class="item-content fontSize14">
                        <p>企业名称：Lotte *********Co.,Ltd</p>
                        <p>
                          企业地址：Lotte Castle **************a, Republic
                          OfСеул, 50-2
                        </p>
                        <p>联系方式：ja*****net</p>
                        <p>进口详单：*********</p>
                        <p>出口详单：*********</p>
                        <p>贸易总览：*********</p>
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="6">
                    <div class="item">
                      <div class="item-title fontSize20">
                        提单详情
                      </div>
                      <div class="item-content fontSize14">
                        <p>主单号：Hlcusyd******</p>
                        <p>供应商 ：Sunraysia Five *********</p>
                        <p>联系方式：ja*****net</p>
                        <p>日期：2022年****</p>
                        <p>采购商：Bel Canto F*******</p>
                        <p>联系方式：ja*****net</p>
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="6">
                    <div class="item">
                      <div class="item-title fontSize20">
                        产品信息
                      </div>
                      <div class="item-content fontSize14">
                        <p>HS编码：200919,20097******</p>
                        <p>数量：3630****</p>
                        <p>
                          出口详单：STAR CRANBERRY 770 CARTONS OF 5 STAR
                          CRANBERRY 250ML X 12 1320 CARTONS OF 5 STAR ORANGE 352
                          CARTONS OF 5 STAR MANGO 660 CARTONS OF 5 STAR APPLE
                          528 CARTONS OF 5 STAR PINEAPPLE HS CODES 200981,
                          200919, 2********
                        </p>
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="6">
                    <div class="item">
                      <div class="item-title fontSize20">
                        货运信息
                      </div>
                      <div class="item-content fontSize14">
                        <p>主单号：Hlcusyd******</p>
                        <p>供应商 ：Sunraysia Five *********</p>
                        <p>联系方式：ja*****net</p>
                        <p>日期：2022年****</p>
                        <p>采购商：Bel Canto F*******</p>
                        <p>联系方式：ja*****net</p>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </div>
              <div class="modal-login">
                <ab-modal-login-btn-vue>
                  <span slot="action-title">0元企业认证，免费体验</span>
                </ab-modal-login-btn-vue>
              </div>
              <div class="map_bottom"></div>
            </div>
            <span slot="expandIcon"></span>
          </a-table>
        </div>
        <div class="block-pagination">
          <a-pagination
            :total="total"
            :show-total="(total) => `共计 ${total} 条`"
            :page-size="20"
            v-model="current"
            @change="onPageChange"
          />
        </div>
      </div>
    </div>
  </ab-modal>
</template>

<script>
import { customsWebSearch, deepSearch } from "@/api/app-crm.js";
import moment from "moment";
import AbModal from "@/components/AbModal.vue";
import AbModalLoginBtnVue from "@/components/AbModalLoginBtn.vue";
import getUniqueCode from "@/utils/uuid";

const columns = [
  {
    title: "供应商",
    dataIndex: "exportCustomerName",
    width: "15%",
    ellipsis: true,
  },
  {
    title: "采购商",
    dataIndex: "importCustomerName",
    width: "15%",
    ellipsis: true,
  },
  {
    title: "产品描述",
    dataIndex: "commodity",
    width: "25%",
    ellipsis: true,
  },
  {
    title: "原产地",
    dataIndex: "exportCountry",
    width: "10%",
    ellipsis: true,
  },
  {
    title: "目的地",
    dataIndex: "importCountry",
    width: "10%",
    ellipsis: true,
  },
  {
    title: "数据来源",
    dataIndex: "dataSource",
    width: "15%",
    ellipsis: true,
  },
  {
    title: "日期",
    dataIndex: "time",
    width: "10%",
    customRender: (time, row, index) => {
      if (time === "日期") return time;
      return moment(time).format("YYYY-MM-DD");
    },
    // ellipsis: true,
  },
];

export default {
  props: ["visible", "keywords", "queryField"],
  components: {
    AbModal,
    AbModalLoginBtnVue,
  },
  data() {
    return {
      columns,
      errorMsgStatus: false,
      modalTitle: "",
      confirmLoading: false,
      current: 1,
      loading: false,
      // form: this.$form.createForm(this, { name: 'dynamic_rule' }),
      sourceData: [],
      relationData: {},
      expandedRowKeys: [],

      headerBody: [
        {
          id: "headField",
          exportCustomerName: "供应商",
          importCustomerName: "采购商",
          commodity: "产品描述",
          exportCountry: "原产地",
          importCountry: "目的地",
          dataSource: "数据来源",
          time: "日期",
        },
      ],
      total: 0,
      checkDate: moment().format("YYYY-MM-DD"),
      pagination: {
        current: 1,
        pageSize: 7,
        total: 0,
        // showTotal: 'total => ``',
        showTotal: (total) => `共计${total}条`,
        onChange: (page) => {
          console.log(page);
        },
      },
    };
  },

  mounted() {
    // console.log(this.record, '------this.record------');
  },

  watch: {
    // watch 监听 props 中的值
    keywords(newVal, oldVal) {
      if (newVal) {
        this.fetchData({ [this.queryField]: newVal });
      }
    },
  },

  methods: {
    handleCancel(e) {
      // this.visible = false;
      this.$emit("cancel");
    },

    listChangePage() {},

    async fetchData(params) {
      this.loading = true;
      const uuid = await getUniqueCode();
      console.log(uuid, "--------uuiduuid------------");
      let param = {
        ...params,
        uuid: uuid,
        pageNo: this.current,
      };

      customsWebSearch(param).then((data) => {
        if (data.code === 3007001) {
          this.errorMsgStatus = true;
          this.modalTitle = "搜索提示";
          // this.$message.info({
          //   content: data.message,
          //   duration: 5,
          // });
          // this.$emit('cancel');
          return;
        }
        console.log(data, "=======response========");
        let sourceData = data.data.list ? data.data.list : [];
        // const pagination = { ...this.pagination };
        // pagination.total = 500;
        this.total = data.data.pages.totalCount || 0;
        this.sourceData = sourceData;
        // this.pagination = pagination;
        this.loading = false;
      });
    },

    showRelation(item, index) {
      deepSearch({ url: item.link }).then((data) => {
        console.log(data, "=======showRelation========");
        let rData = data.data.emailList ? data.data.emailList : [];
        let relationData = rData.slice(0, 10);
        // const pagination = { ...this.pagination };
        // pagination.total = 500;
        // // pagination.total = pages.totalCount || 100;
        console.log(relationData, "=======showRelation========");
        this.relationData = {
          [index]: relationData,
        };
        this.$nextTick(function() {});
        // this.pagination = pagination;
        // this.loading = false;
      });
    },

    onPageChange(page, pageSize) {
      this.current = page;
      this.fetchData({ [this.queryField]: this.keywords });
    },

    expandedRowsChange(expandedRowKeys) {
      console.log(" expandedRowKeys ", expandedRowKeys);
      this.expandedRowKeys = [expandedRowKeys[expandedRowKeys.length - 1]];
    },
  },
};
</script>

<style lang="sass" scoped>
::v-deep tr.ant-table-expanded-row{
  background:#fff;
}
    .map_bottom {
    background: linear-gradient(to top,rgb(255,255,255,1),transparent);
    height:300px;
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0px;
    index: 1;
}
::v-deep .ant-list-split .ant-list-item{
    border: none;
  }
::v-deep .ant-table-row-expand-icon-cell{
  width: auto;
  }
  .ab-list{
    width: 100%;
    min-height: 300px;
    height: calc(100vh - 200px);

    padding: 40px 80px 0px 80px;

    .block-tableHeader{
    height: 60px;
    background: #F4F9FF;
    border-radius: 20px 20px 0px 0px;
    ::v-deep .ant-table-tbody > tr > td{
          padding:  0px;
    line-height: 60px;
      border-bottom:0px;
      color:#333;
      font-size:18px;
      text-align: center;
    }
    }
    .block-tableBody{
      height: calc(100% - 130px);
      overflow: auto;
          margin-bottom: 20px;
        border-radius: 0px 0px 20px 20px;
        border: 1px solid #EFEFEF;
        border-top:none;
      ::v-deep .ant-table-tbody > tr > td{
        color:#333;
            font-size:16px;
            padding-top:20px;
            padding-bottom:20px;

      }

      ::v-deep .ant-table-tbody > tr > td:nth-child(2),::v-deep .ant-table-tbody > tr > td:nth-child(3),::v-deep .ant-table-tbody > tr > td:nth-child(4){
      color: #2B68FF;
      }
      .item{
        padding-bottom: 40px;
      }
      .item-title{
        position: relative;
        padding-left: 17px;
        height: 27px;
        font-family: AlibabaPuHuiTiM;
        font-weight: normal;
        color: #2B68FF;
        line-height: 27px;
            font-size: 20px;

      }

      .item-title:before{
          position: absolute;
          content: ' ';
          width: 4px;
          height: 27px;
          left: 0px;
          line-height: 27px;
          background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
        }

      .item-content{
        padding-top: 17px;
        height: 28px;
        font-family: Alibaba-PuHuiTi-R;
        font-weight: normal;
        color: #333646;
        p{

          font-size:14px;
          margin-bottom: 6px;
        }
      }

      .modal-login{
        margin-top: 160px;
        margin-bottom:20px;
            position: relative;
    z-index: 1;
      }

      .item-opacity{
        opacity: 0.6;
      }

    }
    .block-pagination{
      height: 50px;
      text-align: right;
      ::v-deep .ant-pagination-total-text{
        float: right;
        padding-left: 5px;
      }
    }
  }
</style>
